import { Component, Input, ViewChild, ViewContainerRef } from '@angular/core';
@Component({
    selector: 'icon-ald',
    template: `
        <ng-template #template>
            <svg width="20" height="20" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg"  [ngClass]="class">
                <path
                    opacity="0.8"
                    d="M9 4.25V0H2.75C2.33437 0 2 0.334375 2 0.75V8H0.25C0.1125 8 0 8.1125 0 8.25V8.75C0 8.8875 0.1125 9 0.25 9H4.65312C4.74687 9 4.83438 9.05312 4.87813 9.1375L5.5 10.3813L7.275 6.82812C7.36562 6.64375 7.63125 6.64375 7.72188 6.82812L8.80625 9H11C11.275 9 11.5 9.225 11.5 9.5C11.5 9.775 11.275 10 11 10H8.19063L7.5 8.61875L5.725 12.1719C5.63438 12.3562 5.36875 12.3562 5.27812 12.1719L4.19063 10H2V15.25C2 15.6656 2.33437 16 2.75 16H13.25C13.6656 16 14 15.6656 14 15.25V5H9.75C9.3375 5 9 4.6625 9 4.25ZM13.7812 3.28125L10.7219 0.21875C10.5813 0.078125 10.3906 0 10.1906 0H10V4H14V3.80938C14 3.6125 13.9219 3.42188 13.7812 3.28125Z"
                    fill="currentColor"
                />
            </svg>
        </ng-template>
    `,
})
export class IconAldComponent {
    @Input() class: any = '';
    @ViewChild('template', { static: true }) template: any;
    constructor(private viewContainerRef: ViewContainerRef) {}
    ngOnInit() {
        this.viewContainerRef.createEmbeddedView(this.template);
        this.viewContainerRef.element.nativeElement.remove();
    }
}
